module.exports = __webpack_public_path__ + "img/logo.438ee31.png";